import type { TscAuthState } from './types';

export const initialTscAuthState: TscAuthState = {
  authenticated: false,
  identity: null,
  loading: true,
};
